import { SurveyReferralAnswer, SurveyReferralParams } from '@surveycake/logic-engine';
import {
  checkShortenData,
  encrypt,
  getDat,
  getDeryptKeys,
  getShortenData,
  ReferralCryptKeys,
  saveLog
} from 'app/core/http';
import { Exception } from 'app/core/status';
import CryptoJS from 'crypto-js';

export interface DecryptResult {
  svid: string;
  sn: SurveyReferralAnswer;
  params: SurveyReferralParams;
}

async function decryptFile(
  content: string,
  { hash, iv }: ReferralCryptKeys
): Promise<DecryptResult> {
  try {
    //	@ts-ignore
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(content)
    });
    const decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      CryptoJS.enc.Utf8.parse(hash),
      {
        iv: CryptoJS.enc.Utf8.parse(iv)
      }
    );

    const result = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

    Object.keys(result.sn).forEach(sn => {
      const value = result.sn[sn];
      result.sn[sn] = value instanceof Array ? value : [value];
    });

    return result;
  } catch (error) {
    throw error;
  }
}

async function decrypt32(
  surveyHash: string,
  token: string,
  keys: ReferralCryptKeys
) {
  try {
    const data = await encrypt(surveyHash, token);
    return decryptFile(data.enc, keys);
  } catch (error) {
    throw error;
  }
}

async function decrypt7or8(token: string, keys: ReferralCryptKeys) {
  try {
    const res = await checkShortenData(token);
    if (res.status === 200) {
      const json = await getShortenData(token);

      return decryptFile(json.enc, keys);
    }

    return;
  } catch (error) {
    throw error;
  }
}

async function decryptOther(token: string, keys: ReferralCryptKeys) {
  try {
    const text = await getDat(token);
    return decryptFile(text, keys);
  } catch (error) {
    throw error;
  }
}

async function decrypt(surveyHash: string, token: string) {
  try {
    const keys = await getDeryptKeys(surveyHash, token);

    if (token.length === 32) {
      return await decrypt32(surveyHash, token, keys);
    }

    const result =
      (await decrypt7or8(token, keys)) || (await decryptOther(token, keys));

    saveLog(surveyHash, token);

    return result;
  } catch (error) {
    throw error;
  }
}

/**
 * To decrypt the referral.
 */
export async function initialReferral(surveyHash: string, referral: string) {
  try {
    const result = await decrypt(surveyHash, referral);
    return result ?
    {
      sn: result.sn,
      params: result.params
    }
    :
    undefined;

  } catch (error) {
    throw new Exception('NOT_FOUND');
  }
}
